import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/providers/physician-dashboard-pregnancy-monitoring/#webpage",
   "url": "https://www.futurefamilyai.com/providers/physician-dashboard-pregnancy-monitoring/",
   "name": "Physician Dashboard for Pregnancy | FutureFamilyAI",
   "description": "See consented cuff readings, symptoms and wellness trends over time in one clinician view — with status history and care-team notes.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "EMR Integration",
     "item": "https://www.futurefamilyai.com/providers/emr-integration/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Physician Dashboard",
     "item": "https://www.futurefamilyai.com/providers/physician-dashboard-pregnancy-monitoring/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "What does the physician dashboard show?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Consented readings, symptoms, wellness trends, status history and care-team notes."
     }
    },
    {
     "@type": "Question",
     "name": "Do patients see the same view?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Patients see a simplified color status and guidance, not numeric risk scores."
     }
    },
    {
     "@type": "Question",
     "name": "Can I export data?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, as a summary report."
     }
    },
    {
     "@type": "Question",
     "name": "Is the dashboard real-time?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Data syncs periodically and is not monitored around the clock."
     }
    },
    {
     "@type": "Question",
     "name": "How do patients connect to my practice?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "They accept your invitation and authorize sharing."
     }
    },
    {
     "@type": "Question",
     "name": "Is there a cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No fee for practices during the pilot."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function ProvidersPhysicianDashboardPregnancyMonitoringPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/providers/emr-integration">EMR Integration</Link>
              <span>›</span>
              <span>Physician Dashboard</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                The FutureFamilyAI physician dashboard groups a patient&apos;s
                consented validated-cuff readings, symptom reports and
                smartwatch wellness trends over time, alongside status history
                and care-team notes.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Physicians &amp; OB providers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Patient-generated health data is health-related data
                      created, recorded or gathered by patients to help address
                      a health concern. (ONC / HealthIT.gov)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Everything on one timeline · Source-labeled data ·
                      Care-team notes included
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PROVIDER GUIDE</span>
            <h1>Physician Dashboard for Pregnancy Monitoring</h1>
            <p className="ffh-answer speakable-content">
              The FutureFamilyAI physician dashboard groups a patient&apos;s
              consented validated-cuff readings, symptom reports and smartwatch
              wellness trends over time, alongside status history and care-team
              notes. Clinicians review context; color statuses are prompts for
              attention, not diagnoses. The dashboard supports — never replaces
              — clinical judgment and your practice&apos;s triage protocols. See
              the dashboard in a demo.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Clinician reviewing a pregnancy monitoring trend dashboard"
              >
                <figcaption>
                  <b>Photo slot</b> · Close-up over the shoulder of a clinician
                  looking at a laptop with abstract trend lines (no numbers, no
                  text), stethoscope on desk.
                  <br />
                  <b>Alt:</b> Clinician reviewing a pregnancy monitoring trend
                  dashboard
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Patient-generated health data is health-related data
                    created, recorded or gathered by patients to help address a
                    health concern.
                    <cite>
                      Source:{" "}
                      <a href="https://www.healthit.gov/topic/scientific-initiatives/pcor/patient-generated-health-data-pghd">
                        ONC / HealthIT.gov
                      </a>
                    </cite>
                  </li>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What you see</h2>
                <ul>
                  <li>Cuff readings with timestamps</li>
                  <li>Symptoms reported at measurement</li>
                  <li>Heart rate, PRV, sleep, activity trends</li>
                  <li>Status history and review notes</li>
                  <li>Export as a summary</li>
                </ul>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>What does the physician dashboard show?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Consented readings, symptoms, wellness trends, status
                        history and care-team notes.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Do patients see the same view?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Patients see a simplified color status and guidance, not
                        numeric risk scores.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can I export data?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>Yes, as a summary report.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Is the dashboard real-time?</summary>
                    <div className="ffh-ans">
                      <p>
                        No. Data syncs periodically and is not monitored around
                        the clock.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How do patients connect to my practice?</summary>
                    <div className="ffh-ans">
                      <p>They accept your invitation and authorize sharing.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Is there a cost?</summary>
                    <div className="ffh-ans">
                      <p>No fee for practices during the pilot.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/providers/emr-integration">EMR Integration →</Link>
                  <Link to="/providers">For Physicians →</Link>
                  <Link to="/providers/epic-integration-patient-generated-data">
                    Epic Patient-Generated Data →
                  </Link>
                  <Link to="/providers/how-to-recommend-future-family">
                    Recommend FutureFamilyAI →
                  </Link>
                  <Link to="/providers/clinical-protocol-acog-smfm">
                    Clinical Protocol →
                  </Link>
                  <Link to="/providers/emr-systems-supported">
                    Supported EMR Systems →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.patientsmedical.com">
                    https://www.patientsmedical.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What you see</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
